import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { InfoCard } from '@backstage/core-components';
import { useLinkGroups } from './useLinkGroups';

const useStyles = makeStyles(theme => ({
  group: { '&:not(:last-child)': { marginBottom: theme.spacing(3) } },
  list: {
    listStyle: 'none',
    margin: theme.spacing(1, 0, 0),
    padding: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
    gap: theme.spacing(1),
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    minHeight: 44,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    fontWeight: 600,
    textDecoration: 'none',
    transition: 'background-color 150ms ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      textDecoration: 'none',
    },
    '&:focus-visible': {
      outline: `3px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  icon: { fontSize: 18, flexShrink: 0 },
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
  },
}));

export const LinksCard = () => {
  const classes = useStyles();
  const groups = useLinkGroups();
  if (groups.length === 0) {
    return (
      <InfoCard>
        <Typography variant="body2">
          No links configured. Add them under usefulLinks in the app config.
        </Typography>
      </InfoCard>
    );
  }
  return (
    <InfoCard>
      {groups.map(group => (
        <section key={group.title} className={classes.group}>
          <Typography variant="subtitle1" component="h2">
            {group.title}
          </Typography>
          <ul className={classes.list}>
            {group.links.map(link => (
              <li key={link.name}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.link}
                >
                  <span>{link.name}</span>
                  <OpenInNewIcon className={classes.icon} aria-hidden="true" />
                  <span className={classes.srOnly}> (opens in a new tab)</span>
                </a>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </InfoCard>
  );
};
